import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link as ReactLink } from 'react-router-dom';

import {
    Link,
    Icon,
} from 'yurstrap';

import ModalLink from '../../components/ModalLink';

import { getScopeSelector } from '../../commons/reduxModules/Authentication';
import Scopes from '../../constants/Scopes';

import Routes from '../constants/Routes';

const propTypes = {
    className: PropTypes.string,
    scope: PropTypes.string.isRequired,
    style: PropTypes.object,
    to: PropTypes.string,
};

const defaultProps = {
    className: '',
    style: null,
    to: '',
};

class BackLink extends Component {

    render() {
        const {
            className,
            to,
            scope,
            style,
        } = this.props;
        const linkProps = {
            componentClass: ReactLink,
        };
        if (Scopes.USER !== scope) {
            linkProps.componentClass = ModalLink;
            linkProps.modalName = 'support';
        }
        return (
            <Link
                color="light"
                style={style || { position: 'absolute', top: '40px', zIndex: 2 }}
                className={`${className}`}
                to={to || Routes.HOME_PAGE.link}
                /* eslint-disable-next-line react/jsx-props-no-spreading */
                {...linkProps}
            >
                <Icon icon="chevron-left mr-1" />
                Retour
            </Link>
        );
    }

}

BackLink.propTypes = propTypes;
BackLink.defaultProps = defaultProps;

function mapStateToProps(state) {
    return {
        scope: getScopeSelector(state),
    };
}

export default connect(
    mapStateToProps,
)(BackLink);
